import React from 'react';
import { AmityUiKitProvider, AmityUiKitSocial, AmityPostDetailPage } from '@frn/amityco-ui-kit-open-source';
// eslint-disable-next-line import/no-webpack-loader-syntax
import socialPlusStyles from '!!css-loader?{"sourceMap":false,"exportType":"string"}!@frn/amityco-ui-kit-open-source/dist/index.css';
import overrideStyles from '!!css-loader?{"sourceMap":false,"exportType":"string"}!./globalOverrides.css';
import posteDetailOverrides from '!!css-loader?{"sourceMap":false,"exportType":"string"}!./postDetailOverrides.css';
import ErrorBoundary from '../ErrorBoundary';
import useAutoJoinSocialPlusCommunity from './useAutoJoinSocialPlusCommunity';

const SocialPlusAppContent = ({ useForum = true, usePostDetailPage, postId, styleObject, autoJoinCommunityId }) => {
  if (autoJoinCommunityId) useAutoJoinSocialPlusCommunity(autoJoinCommunityId);
  return (
    <div
      style={
        styleObject || {
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100vw',
          height: '100dvh'
        }
      }
      className={useForum && 'socialplus-uikit-wrapper'}
    >
      <style type="text/css" scoped>
        {socialPlusStyles}
      </style>
      <style>{useForum && overrideStyles}</style>
      <style>{usePostDetailPage && posteDetailOverrides}</style>
      {usePostDetailPage && <AmityPostDetailPage id={postId} />}
      {useForum && <AmityUiKitSocial />}
    </div>
  );
};

function SocialPlusApp(props) {
  const {
    user,
    socialPlusApiKey,
    getAuthToken,
    useProvider = true,
    useForum = true,
    usePostDetailPage,
    postId,
    styleObject
  } = props;
  if ((!user || !socialPlusApiKey) && useProvider) {
    console.error('SocialPlusApp: Missing user or socialPlusApiKey', user, socialPlusApiKey, useProvider);
    return <>Error loading the community forum</>;
  }

  const { userId, firstName, lastName } = user;
  const userIdString = userId.toString();
  const displayName = `${firstName} ${lastName.charAt(0).toUpperCase()}`;

  return (
    <ErrorBoundary msg="Error loading the community forum, please refresh your browser.">
      <SocialPlusAppContent {...props} />
    </ErrorBoundary>
  );
}

export default SocialPlusApp;
export { SocialPlusAppContent };
